import { useEffect, useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { ApiClientError } from '../../../shared/api/client.js';
import { t } from '../../../shared/i18n/index.js';
import { useAuthStore } from '../model/auth.store.js';
import { useCaptcha } from '../model/useCaptcha.js';
import type { LoginFormValues } from '../model/login-form.js';
import { LoginPage } from './LoginPage.js';

/**
 * Kirish sahifasining "simli" qismi: do'kon, xatolar va yo'naltirish.
 * Ko'rinishning o'zi (`LoginPage`) tarmoqni bilmaydi va alohida sinaladi.
 */
export const LoginRoute = () => {
  const navigate = useNavigate();
  const login = useAuthStore((s) => s.login);
  const accessToken = useAuthStore((s) => s.accessToken);
  const [error, setError] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState(false);
  const captcha = useCaptcha();

  // Kirgan odam kirish sahifasida qolib ketmasin (masalan "orqaga" tugmasidan).
  useEffect(() => {
    if (accessToken !== null) void navigate({ to: '/', replace: true });
  }, [accessToken, navigate]);

  const handleSubmit = (values: LoginFormValues): void => {
    if (captcha.token === null) return;
    setError(undefined);
    setLoading(true);
    void login({ ...values, captchaToken: captcha.token })
      .then(() => navigate({ to: '/', replace: true }))
      .catch((cause: unknown) => {
        // Xom obyekt emas, serverning o'zbekcha xabari ko'rsatiladi.
        setError(
          cause instanceof ApiClientError ? cause.message : t('login.unexpectedError'),
        );
        /*
         * Kod QAYTA so'raladigan yagona hol — serverning o'zi tasdiqni rad
         * etgani (400: muddati tugagan yoki manzil o'zgargan). Parol
         * noto'g'ri bo'lsa (401) tasdiq joyida qoladi: aks holda odam har
         * xato paroldan keyin yana topishmoq yechishga majbur bo'lardi.
         */
        if (cause instanceof ApiClientError && cause.status === 400) captcha.invalidate();
      })
      .finally(() => setLoading(false));
  };

  return (
    <LoginPage onSubmit={handleSubmit} error={error} loading={loading} captcha={captcha} />
  );
};
